import { useState } from "react"
import MainDashboardFilters from "../dashboardfilters/maindashboardfilters"
import MainSearch from "../dashboardfilters/mainsearch"
import PropModal from "../modals/propmodal"
import MainTable from "../tables/maintable"

const MainDashboard=()=>{
  const [isModal,setIsModal]=useState(false)
  const [filterby,setFilterBy]=useState('No Grouping')
    return(<>
    <div className="sm:pt-7 sm:px-8 mb-12">

<MainDashboardFilters/>
<MainSearch filterby={filterby} setFilterBy={setFilterBy}/>
<div className="p-4 text-gray-600 font-normal text-sm text-start leading-5">
  Last edited by: John Do
</div>
<MainTable filterby={filterby}/>

    </div>
    
<PropModal isOpen={false} setIsOpen={setIsModal}/>
    </>)
}
export default MainDashboard